import { PermanentJobsApi } from '../clients';

/**
 * Updates an existing job posting
 * Service layer that orchestrates the API call to update a job posting
 *
 * @param {import('../types/UpdateJobPosting.parameters').IUpdateJobPostingPayload} payload - Request payload
 *
 * @returns {Promise<void>}
 *   Returns nothing on success (204 No Content)
 */
export const updateJobPosting = async (payload) => {
  await PermanentJobsApi.updateJobPosting(payload);
};
